import { AssessmentStatus, Leads } from "../../../../model/leads/leads";
import RequestTable, { Column } from "./RequestTable";
import styles from "../RequestPage.module.scss";
import { formatDate } from "../../../../utils";
import { ClockLoader } from "../../../../assets/icons";

export enum RequestType {
	New,
	Active,
	Closed,
}

interface RequestTabProps {
	data: Leads[];
	type: RequestType;
	onItemClicked: (item : Leads) => void;
	isLoading: boolean;
}
const RequestTab = ({ data, type, onItemClicked }: RequestTabProps) => {

	const handleDetailView = (item: Leads) => {
		onItemClicked(item);
	};

	const getStatusClass = (status: AssessmentStatus) => {
		switch(status) {
			case AssessmentStatus.CheckingDigitalLoadAssessment:
				return {styleName: styles.status_badge_pending, text: "Pending"};
			case AssessmentStatus.ScheduledPhysicalLoadAssessment:
				return { styleName: styles.status_badge_scheduled, text: "Scheduled"}
				case AssessmentStatus.RescheduledPhysicalLoadAssessment:
				return { styleName: styles.status_badge_rescheduled, text: "Re Scheduled"}
			case AssessmentStatus.CarringOutPhysicalLoadAssessment:
				return { styleName: styles.status_badge_progress, text: "In Progress"}
			case AssessmentStatus.OverduePhysicalLoadAssessment:
				return { styleName: styles.status_badge_overdue, text: "Overdue"}
			case AssessmentStatus.SendingProductsThatFit:
				return { styleName: styles.status_badge_completed, text: "Done" }
			default:
				return { styleName: "", text: "-" };
		}
	};

	const columns: Column<Leads>[] = [
		{
			header: "CUSTOMER NAME",
			accessor: "user",
			render: item => `${item.user?.firstName || ''} ${item.user?.lastName || ''}`,
		},
		{
			header: "DATE CREATED",
			accessor: "createdAt",
			render: item => formatDate(item.createdAt),
		},
		{
			header: "LOAD ASSESSMENT STATUS",
			accessor: "status",
			render: item => {
				const { styleName, text } = getStatusClass(item.status)
				return <span className={`${styles.status_badge} ${styleName}`}>
					{item.status === AssessmentStatus.CarringOutPhysicalLoadAssessment  && <ClockLoader />} {text}
				</span>
			},
		},
		// {
		// 	header: "TIMELINE",
		// 	accessor: "timeline",
		// 	render: item => <span className={styles.subSubText}>{item.timeline}</span>,
		// },
		{
			header: "VIEW DETAILS",
			accessor: "id",
			render: item => (
				<button className="actionButton" onClick={() => handleDetailView(item)}>
					VIEW DETAILS
				</button>
			),
		},
	];

	return <RequestTable<Leads> columns={columns} data={data} tableContainerClassName={styles.tableContainer} />;
};
export default RequestTab;
